import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminImportMADBs = () => {
  const queryClient = useQueryClient();

  return apiClient.madb.updateMadb.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('MADBs imported successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to import MADBs');
    },
  });
};
